<script setup>
import {nextTick, ref} from 'vue'
import Button from '@/common/Button.vue'

const props = defineProps({
    field: Object,
    currentData: Object,
})

// Template refs and reactive data
const passwordInput = ref(null)
const showInput = ref(false)
const storedPassword = ref(undefined)
const isPasswordTextVisible = ref(false)

// Methods
const showPasswordField = () => {
    showInput.value = true

    storedPassword.value = props.currentData[props.field.name]
    props.currentData[props.field.name] = ''

    nextTick(() => {
        if (passwordInput.value) {
            passwordInput.value.focus()
        }
    })
}

const hidePasswordField = () => {
    showInput.value = false
    props.currentData[props.field.name] = storedPassword.value
    isPasswordTextVisible.value = true
}
</script>

<template>
    <button v-if="!showInput" class="btn btn-light btn-sm" type="button" @click="showPasswordField">
        Change password
    </button>

    <div v-else class="row g-0 align-items-center">
        <div class="col-auto">
            <input
                ref="passwordInput"
                v-model="currentData[field.name]"
                :name="field.name"
                :size="field.size"
                :type="isPasswordTextVisible ? 'text' : 'password'"
                class="form-control" :class="{'is-invalid': field.error}"
                required
            />
        </div>

        <div class="col-auto ps-2">
            <Button :active-value="isPasswordTextVisible"
                    @click="isPasswordTextVisible = !isPasswordTextVisible">
                <i v-if="isPasswordTextVisible" class="bi bi-eye-slash"/>
                <i v-else class="bi bi-eye"/>
            </Button>

            <Button @click="hidePasswordField">
                reset
            </Button>
        </div>
    </div>
</template>